import React, { ReactNode } from "react";
import { containerWidth } from "../utils";

interface ContentSidebarProps {
  children: ReactNode;
  sidebarContent: ReactNode;
  /** Minimum width for the sidebar when visible (defaults to 200px) */
  minSidebarWidth?: number;
  /** Maximum width for the sidebar when visible (defaults to 350px) */
  maxSidebarWidth?: number;
  /** Top offset in pixels for sticky positioning (defaults to 100px) */
  topOffset?: number;
  /** Optional custom class for the outer wrapper */
  className?: string;
}

export const ContentSidebar: React.FC<ContentSidebarProps> = ({
  children,
  sidebarContent,
  minSidebarWidth = 200,
  maxSidebarWidth = 350,
  topOffset = 100,
  className = "",
}) => {
  // Inside ContentSidebar.tsx component
  if (!sidebarContent) {
    return <div className={`w-full mx-auto ${containerWidth}`}>{children}</div>;
  }
  return (
    <div className={`w-full mx-auto ${className}`}>
      {/* Below 1540px: Standard full-width container */}
      <div className={`min-[1540px]:hidden ${containerWidth}`}>{children}</div>

      {/* 1540px and above: Unified split layout */}
      <div className="hidden min-[1540px]:flex min-[1540px]:justify-center min-[1540px]:gap-6 max-w-[1520px] mx-auto px-4 lg:px-6">
        {/* Central main content constrained to your unified width */}
        <main className={`w-full ${containerWidth}`}>{children}</main>

        {/* Dynamic Sidebar space constrained between min and max */}
        <aside
          className="w-full shrink-0 sticky self-start"
          style={{
            minWidth: `${minSidebarWidth}px`,
            maxWidth: `${maxSidebarWidth}px`,
            top: `${topOffset}px`,
          }}
        >
          {sidebarContent}
        </aside>
      </div>
    </div>
  );
};
